import React from 'react'
import GameSummaryNavigation from './GameSummaryNavigation'
import GameSummaryWarning from './GameSummaryWarning'

const GameSummaryHomeWarning = () => {
	return (
		<div style={{ overflowX: 'hidden' }}>
			<GameSummaryNavigation />
			<GameSummaryWarning />
		</div>
	)
}

export default GameSummaryHomeWarning
